import { ApiClient } from '../../../shared/api/ApiClient';

export interface TrackingEventRecord {
  id: string;
  consignmentId: string;
  status: string;
  description: string | null;
  occurredAt: string;
  createdAt: string;
  consignment?: {
    id: string;
    tntConsignmentNumber: string | null;
    shopifyOrderName: string | null;
  };
}

export interface WebhookLogRecord {
  id: string;
  topic: string;
  shopDomain: string;
  shopifyOrderId: string | null;
  receivedAt: string;
  processedAt: string | null;
  error: string | null;
}

export interface PaginatedResponse<T> {
  items: T[];
  nextCursor: string | null;
}

export function listTrackingEvents(
  api: ApiClient,
  params: { cursor?: string; limit?: number } = {},
): Promise<PaginatedResponse<TrackingEventRecord>> {
  const q = new URLSearchParams();
  if (params.cursor) q.set('cursor', params.cursor);
  if (params.limit) q.set('limit', String(params.limit));
  const qs = q.toString();
  return api.get<PaginatedResponse<TrackingEventRecord>>(
    `/admin/api/tracking-events${qs ? `?${qs}` : ''}`,
  );
}

export function listWebhookLogs(
  api: ApiClient,
  params: { cursor?: string; limit?: number; topic?: string } = {},
): Promise<PaginatedResponse<WebhookLogRecord>> {
  const q = new URLSearchParams();
  if (params.cursor) q.set('cursor', params.cursor);
  if (params.limit) q.set('limit', String(params.limit));
  if (params.topic) q.set('topic', params.topic);
  const qs = q.toString();
  return api.get<PaginatedResponse<WebhookLogRecord>>(
    `/admin/api/webhook-logs${qs ? `?${qs}` : ''}`,
  );
}
